// core.js v3.5.2

//----------------------------------------------------------------------------
// ★pzprオブジェクト
//---------------------------------------------------------------------------
/* extern */
var pzpr = {
	version: "f84f91b0"
};

if (typeof module === "object" && module.exports) {
	module.exports = pzpr;
} else {
	this.pzpr = pzpr;
}
